// import { useEffect, useRef } from 'react';
import dynamic from 'next/dynamic';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';

import { APP_URL, CONTENT_DEFAULT } from 'src/constants';

import Layout from 'src/components/layouts';

import { convertObjPath, rewriteTxt, timestamp } from 'src/utils/helper';

import { GET, GET_ARTICLES } from 'src/utils/services';
import useUser from 'src/utils/useUser';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';

const EmptyArticle = dynamic(import('src/components/empty'), { ssr: false });
const ReadFullPicture = dynamic(import('src/components/layouts/articles/picture'), { ssr: true });
const ReadFullVideo = dynamic(import('src/components/layouts/articles/video'), { ssr: true });
const SectionAffiliate = dynamic(import('src/components/sections/section-event/section-affiliate'));
const PageDetail = props => {
  const data = useUser();
  const sessionSevId = data?.user ? decryptionClient(data?.user) : null;
  if (isEmpty(props?.article)) return <EmptyArticle sessionSevId={sessionSevId} />;

  const checkVideo = props?.article?.video_src !== null;
  const checkSectionInfographic = props?.article?.section?.en === 'infographic';

  return (
    <>
      {!isEmpty(props?.dataAffiliate) && <SectionAffiliate position={4} data={props?.dataAffiliate} />}
      <Layout sessionSevId={sessionSevId} ads={props?.ads}>
        {checkVideo || checkSectionInfographic ? <ReadFullVideo {...props} /> : <ReadFullPicture {...props} />}
      </Layout>
    </>
  );
};

export async function getServerSideProps({ req, res, params, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    article: [],
    related: [],
    lastNews: [],
    lastContents: [],
    articleSports: [],
    solrRelated: [],
    dataAffiliate: [],
    lineIdDefaultContent: CONTENT_DEFAULT,
    lineContent: [],
    ads: [],
    dataAdsNative: null,
    agent: null
  };

  const { expires, signature } = query;

  const _type = `/${query.type}` || '';
  let preview = '';
  let previewParams = {};
  if (expires && signature) {
    preview = '/preview';
    previewParams = { expires, signature };
  }

  const url = req.url;
  let uri = `contents/${rewriteTxt(params.id)}`;

  if (url.startsWith('/advertorials') || url.startsWith('/pr-news') || url.startsWith('/blogs')) {
    uri = `contents/${params.id}${_type}`;
  }

  if (rewriteTxt(params.id) === 'latest-news') {
    return {
      redirect: {
        destination: `${APP_URL}/category/latest-news`,
        permanent: false
      }
    };
  }

  try {
    // ✅ ยิง 3 APIs แบบ parallel — ลดเวลาจาก 3x → 1x
    const [resData, tagsData, sportData] = await Promise.all([
      GET_ARTICLES(`/api/v1.0/${uri}${preview}${convertObjPath({ ...previewParams })}`, false, true),
      GET(`/api/search/tag${convertObjPath({ name: 'ขอบสนาม' })}`, false),
      GET('/api/v1.0/categories/column', false)
    ]);

    // ✅ Handle 404 หลัง parallel เสร็จ
    if (resData?.statusCode === 404 || isUndefined(resData)) {
      res.setHeader('location', '/');
      res.statusCode = 301;
      res.end();
      return { props: initProps };
    }

    if (!isEmpty(resData?.data)) {
      initProps.article = resData?.data;
      initProps.ads = resData?.ads || [];
      initProps.related = resData?.related || [];
      initProps.lastNews = resData?.last_news || [];
      initProps.solrRelated = resData?.solrRelated || [];
      initProps.dataAffiliate = resData?.affiliate || [];
      initProps.lastContents = tagsData?.data || tagsData || [];
      initProps.articleSports = sportData || [];
      initProps.lineContent = params.id > initProps.lineIdDefaultContent;
      initProps.dataAdsNative = resData?.adsNative || null;
      initProps.agent = req.headers['user-agent'];
    }

    // ✅ Cache HTML ที่ CDN — เก็บ 60s, stale 5min
    res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=300');
  } catch (err) {
    console.error(`${timestamp()} ==========> ARTICLE_DETAIL ERROR : `, err.message);
    initProps.errMessage = err?.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return { props: initProps };
}

export default PageDetail;
